import { BASE_URL } from "@/constants/endpoints";
import { LogisticDayToBlock } from "@/pages/config/logistic/schema/logistic.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let LogisticApiPromise: Promise<AxiosInstance> | null = null;

const getLogisticApi = async (): Promise<AxiosInstance | null> => {
  if (LogisticApiPromise) return LogisticApiPromise;
  LogisticApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return LogisticApiPromise;
};

export interface GetLogisticDaysProps {
  year: number;
  idEquipo: number;
  idTipoModulo: number;
}

export const getLogisticDays = async (props: GetLogisticDaysProps) => {
  const api = await getLogisticApi();
  if (!api) return;

  const response = await api.get(
    `/LogisticaCompleta?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface PatchLogisticDaysProps {
  year: number;
  idEquipo: number;
  idTipoModulo: number;
  diasABloquear: LogisticDayToBlock[];
}

export const patchLogisticDays = async (props: PatchLogisticDaysProps) => {
  const api = await getLogisticApi();
  if (!api) return;

  const response = await api.patch(`/LogisticaCompleta`, props);

  return response.data;
};
